import { nativeJSBridge, nativeJSBridgeSync } from './nativeJSBridge'
import { IBridgeOptions } from './interface'
import formatParams from './util/formatParams'

interface IClient {
  /**
   * 客户编号
   *
   * @type {string}
   * @memberof IClient
   * @example {'clientId': '123123we'}
   */
  clientId: string
}

interface IClientResponse {
  success?: (result: IClient) => void
  fail?: (result: IClient) => void
  complete?: (result: IClient) => void
}

/**
 * 获取客户编号
 *
 * @param {IBridgeOptions<IClientResponse>} { success, fail, complete }
 */
function getClientIdSync({ success, fail, complete }: IBridgeOptions<IClientResponse>) {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getClientId'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params,
    success,
    fail,
    complete
  }
  try {
    nativeJSBridgeSync(opts)
  } catch (error) {
    console.log('getClientIdSync error: ', error)
  }
}

/**
 * 获取客户编号<br>
 * 一个异步接口，支持 Promise 化使用
 *
 * @returns {Promise<IClient>}
 */
function getClientId(): Promise<IClient> {
  const params = formatParams({
    funType: 'userInfo',
    funName: 'getClientId'
  })
  const opts: IBridgeOptions = {
    method: 'winner.hsJsFunction',
    params
  }

  return nativeJSBridge(opts)
}

export { getClientId, getClientIdSync }
